import { getEntityDataSource } from 'areas/dashboards/graph-editor-extensions/datasources/entityDataSource';
import { CustomDataListEntry } from 'controls/designer/features/widgets/custom-data-list/customDataListEntry';
import { CustomDataEntry } from 'controls/designer/customDataEntry';
import { getWidgetDescription } from 'controls/designer/features/widgets/utils/getWidgetDescription';

const i18n = require('core/localization/localization').translator({
    'Shape/{0}': {
		en: 'Shape/{0}',
		no: 'Form/{0}',
    },
});

export function populateCustomDataExtraFields(
	listItems: CustomDataListEntry[],
	customDataItems: CustomDataEntry[],
) {
	listItems.forEach((item) => {
		const customData = customDataItems.find((x) => x.id == item.id);

		if (customData.widgetConfig) {
			item.name = customData.widgetConfig.title;
			const description = getWidgetDescription(customData.widgetConfig.type);
			item.customDataType = description?.fullTitle ?? customData.widgetConfig.type;
		} else if (customData.dataSource) {
			item.name = i18n(
				'Shape/{0}',
				getEntityDataSource().find((x) => x.value == customData.dataSource.type)?.label,
			);
			item.customDataType = customData.dataSource?.type;
		}
	});
}
